// <a-text> using `definePrimitive` helper.
import { definePrimitive } from '../primitives.js';
definePrimitive('a-text', {text: {anchor: 'align', width: 5}});
